export class Colegios{
    constructor(
        public nombre: String,
        public nivel: String,
        public tipo_presupuesto: String
    ){}
}